(function () {
    const inFlight = new WeakSet();
    const completed = new WeakMap();
    const pendingIds = new Map();
    function message(form, key) {
        return form.closest('.cart-telegram').dataset[key] || '';
    }
    function status(form, text, isError) {
        const el = form.querySelector('.cart-telegram__status');
        if (!el) return;
        el.textContent = text;
        el.style.color = isError ? 'var(--color-error, #b00020)' : 'inherit';
    }
    function value(form, name) {
        return String(form.elements.namedItem(name)?.value || '').trim();
    }
    function money(cents, currency) {
        return new Intl.NumberFormat(document.documentElement.lang || 'uk-UA', {
            style: 'currency', currency: currency || 'UAH'
        }).format(Number(cents || 0) / 100);
    }
    async function cartData() {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!res.ok) throw new Error('cart');
        return res.json();
    }
    function updateTotal(cart) {
        document.querySelectorAll('[data-cart-telegram-total]').forEach(el => {
            el.textContent = money(cart.total_price, cart.currency);
        });
    }
    function normalizePhone(phone) {
        let digits = phone.replace(/\D/g, '');
        if (/^0\d{9}$/.test(digits)) digits = '38' + digits;
        return /^380\d{9}$/.test(digits) ? '+' + digits : '';
    }
    async function fingerprint(data) {
        const bytes = new TextEncoder().encode(JSON.stringify(data));
        const digest = await crypto.subtle.digest('SHA-256', bytes);
        return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
    }
    function isRecorded(key) {
        try { return sessionStorage.getItem('eco_order_sent_' + key); } catch { return null; }
    }
    function record(key, id) {
        try { sessionStorage.setItem('eco_order_sent_' + key, id); } catch {}
    }
    function buildMessage(payload, cart, id) {
        const rows = [
            '🛒 НОВЕ ЗАМОВЛЕННЯ', 'Номер заявки: ' + id, '',
            'Ім’я: ' + payload.full_name, 'Телефон: ' + payload.phone,
            'Нова пошта: ' + payload.nova_poshta,
            'ID відділення: ' + payload.np_department_id, '', 'Товари:'
        ];
        for (const item of cart.items) {
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
            rows.push((item.product_title || item.title) + variant + ' ×' + item.quantity + ' — ' + money(item.final_line_price ?? item.price * item.quantity, cart.currency));
        }
        rows.push('', 'Вартість товарів: ' + money(cart.total_price, cart.currency), 'Оплату та доставку потрібно підтвердити з покупцем.');
        return rows.join('\n');
    }
    async function send(proxyUrl, recipient, text, extra) {
        const res = await fetch(proxyUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ recipient, message: text, extra }),
            signal: AbortSignal.timeout(20000)
        });
        const data = await res.json().catch(() => null);
        if (!res.ok || !data || data.ok === false || data.success === false || data.error || !(data.ok === true || data.success === true)) {
            throw new Error('unconfirmed');
        }
        return data;
    }
    function publishAccepted(cart, id) {
        const data = {
            request_id: id, currency: cart.currency || 'UAH', value: cart.total_price / 100,
            items: cart.items.map(item => ({ item_id: String(item.variant_id || item.id), quantity: item.quantity, price: (item.final_price ?? item.price) / 100 }))
        };
        try { window.Shopify?.analytics?.publish?.('eco_choice_order_submitted', data); } catch {}
    }
    document.addEventListener('submit', async function (event) {
        const form = event.target?.matches?.('.cart-telegram__form') ? event.target : null;
        if (!form) return;
        event.preventDefault();
        if (inFlight.has(form)) return;
        if (!form.reportValidity()) return;
        const full_name = value(form, 'full_name');
        const phone = normalizePhone(value(form, 'phone'));
        const np_department_id = value(form, 'np_department_id');
        const np_short_name = value(form, 'np_short_name');
        const np_city = value(form, 'np_city');
        if (full_name.length < 2) { status(form, message(form, 'msgName'), true); return; }
        if (!phone) { status(form, message(form, 'msgPhone'), true); return; }
        if (!np_department_id || !np_short_name || !np_city) { status(form, message(form, 'msgBranch'), true); return; }
        const wrap = form.closest('.cart-telegram');
        const proxyUrl = (wrap.dataset.tgProxyUrl || '').trim();
        const recipient = (wrap.dataset.tgRecipient || '').trim();
        if (!proxyUrl.startsWith('https://') || !recipient) { status(form, message(form, 'msgUnavailable'), true); return; }
        const button = form.querySelector('.cart-telegram__btn');
        inFlight.add(form);
        completed.delete(form);
        if (button) button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status(form, message(form, 'msgSending'), false);
        let started = false;
        try {
            const cart = await cartData();
            if (!cart.items?.length) { status(form, message(form, 'msgEmpty'), true); return; }
            updateTotal(cart);
            const nova_poshta = [np_city, np_short_name, value(form, 'np_street'), value(form, 'np_building')].filter(Boolean).join(', ');
            const payload = { full_name, phone, nova_poshta, np_department_id, np_short_name, np_city };
            const key = await fingerprint({ payload, currency: cart.currency, total: cart.total_price, items: cart.items.map(i => [i.key || i.id, i.quantity, i.final_line_price]) });
            const alreadySent = isRecorded(key);
            if (alreadySent) {
                completed.set(form, key);
                status(form, message(form, 'msgDuplicate') + ' ' + alreadySent, false);
                return;
            }
            const requestId = pendingIds.get(key) || crypto.randomUUID();
            pendingIds.set(key, requestId);
            started = true;
            await send(proxyUrl, recipient, buildMessage(payload, cart, requestId), { payload, cart, request_id: requestId });
            record(key, requestId);
            completed.set(form, key);
            pendingIds.delete(key);
            status(form, message(form, 'msgSuccess') + ' ' + requestId, false);
            publishAccepted(cart, requestId);
        } catch {
            status(form, message(form, started ? 'msgUnconfirmed' : 'msgFailed'), true);
        } finally {
            inFlight.delete(form);
            form.removeAttribute('aria-busy');
            if (button) button.disabled = completed.has(form);
        }
    }, true);
    function allowChangedOrder(event) {
        const form = event.target?.closest?.('.cart-telegram__form');
        if (!form || inFlight.has(form) || !completed.has(form)) return;
        completed.delete(form);
        const button = form.querySelector('.cart-telegram__btn');
        if (button) button.disabled = false;
    }
    document.addEventListener('input', allowChangedOrder);
    document.addEventListener('change', allowChangedOrder);
    async function refresh() {
        if (!document.querySelector('[data-cart-telegram-total]')) return;
        try { updateTotal(await cartData()); } catch {}
    }
    document.addEventListener('cart:update', function () {
        document.querySelectorAll('.cart-telegram__form').forEach(form => {
            if (inFlight.has(form)) return;
            completed.delete(form);
            const button = form.querySelector('.cart-telegram__btn');
            if (button) button.disabled = false;
        });
        refresh();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
})();
